<header class="flex align-items-center justify-content-between border-bottom px-4 bg-white shadow-1">
    <div class="flex mb-md-0">
      <h4 *ngIf="title" class="card-title custom-bold" data-auto-id="tunnel-header-title">{{ title }}</h4>
    </div>
    <div class="flex flex-1 justify-content-end align-items-baseline" data-auto-id="logo" >
      <a [ngClass]="logoClass$ | async" aria-label="Go to homepage" (click)="onLogoClick()"></a>
    </div>
</header>


<div class="claim-details">
  <p-dialog [modal]="true" [closable]="false" [(visible)]="showDialog" [style]="{ width: '22rem' }">
    <ng-template #header>
      <div class="flex align-items-center justify-content-center relative w-full">
        <span class="text-slate-800 text-sm sm:text-base custom-bold">Leave site?</span>
      </div>
    </ng-template>
    <p-divider styleClass="my-0"></p-divider>
    <div class="px-3 pb-4 text-sm sm:text-base">
      <p class="my-5 text-center">Changes that you made may not be saved.</p>
      <div class="flex gap-3 align-items-center justify-content-center">
        <p-button [rounded]="true" severity="secondary" variant="outlined" label="Cancel" class="w-full" [raised]="true"
          styleClass="w-full text-sm sm:text-base" (click)="showDialog = false" />
        <p-button label="Leave" [rounded]="true" severity="danger" class="w-full"
          styleClass="w-full text-sm sm:text-base bg-rose-600 text-white" (click)="navigateToDashboard()"  />
      </div>
    </div>
  </p-dialog>
</div>
<app-ffs-banner *ngIf="showFfsBanner"></app-ffs-banner>